// Shared constants + small helpers for the Sponsors admin tab.

export const TIERS = [
  { value: 'platinum',  label: 'Platinum',  color: '#e5e4e2' },
  { value: 'gold',      label: 'Gold',      color: '#FFD700' },
  { value: 'silver',    label: 'Silver',    color: '#C0C0C0' },
  { value: 'bronze',    label: 'Bronze',    color: '#cd7f32' },
  { value: 'supporter', label: 'Supporter', color: '#888888' },
];

export const STATUSES = ['active', 'pending', 'expired', 'declined'];

export const blankSponsor = () => ({
  business_name: '',
  contact_name: '',
  email: '',
  phone: '',
  tier: 'supporter',
  amount: 0,
  sponsorship_date: '',
  renewal_date: '',
  status: 'active',
  notes: '',
  logo_url: '',
  website: '',
});

export const tierMeta = (tier) =>
  TIERS.find((t) => t.value === tier) || TIERS[TIERS.length - 1];
